import api from './api';

export type UserStatus = 'ATIVO' | 'INATIVO' | 'BLOQUEADO' | 'PENDENTE';
export type UserRole = 'ADMIN' | 'OPERADOR' | 'GESTOR_JURIDICO' | 'JURIDICO' | 'JURIDICO_AUXILIAR' | 'ANALISTA' | 'ORCAMENTO' | 'SECRETARIA' | 'CONVENIOS' | 'CAMARA' | 'VEREADOR';

export interface UserAdminDTO {
  id: number;
  nomeCompleto: string;
  documento?: string | null;
  email: string;
  telefone?: string | null;
  cargoFuncao?: string | null;
  secretaria?: string | null;
  parlamentarId?: string | null;
  procuradorSupervisorId?: number | null;
  procuradorSupervisorNome?: string | null;
  status: UserStatus;
  role: UserRole;
  /** Gestor da Parceria — atribuição booleana, só válida quando role = SECRETARIA */
  gestorParceria?: boolean;
  /** Operador de secretaria — OPERADOR que atua em nome de uma secretaria (nome em `secretaria`) */
  operadorSecretaria?: boolean;
  dataCriacao?: string;
  dataAtualizacao?: string;
}

export interface ProcuradorJuridicoDTO {
  id: number;
  nomeCompleto: string;
  email: string;
  role?: UserRole;
  procuradorSupervisorId?: number | null;
  procuradorSupervisorNome?: string | null;
}

export interface UserAdminCreateRequest {
  nomeCompleto: string;
  documento?: string;
  email: string;
  telefone?: string;
  cargoFuncao?: string;
  secretaria?: string;
  parlamentarId?: string | null;
  procuradorSupervisorId?: number | null;
  status?: UserStatus;
  role?: UserRole;
  password: string;
  gestorParceria?: boolean;
  operadorSecretaria?: boolean;
}

export interface UserAdminUpdateRequest {
  nomeCompleto?: string;
  documento?: string;
  email?: string;
  telefone?: string;
  cargoFuncao?: string;
  secretaria?: string;
  parlamentarId?: string | null;
  procuradorSupervisorId?: number | null;
  status?: UserStatus;
  role?: UserRole;
  password?: string;
  gestorParceria?: boolean;
  operadorSecretaria?: boolean;
}

const userAdminService = {
  list: async (): Promise<UserAdminDTO[]> => {
    const { data } = await api.get<UserAdminDTO[]>('/admin/users');
    return data;
  },

  listProcuradoresJuridicos: async (): Promise<ProcuradorJuridicoDTO[]> => {
    const { data } = await api.get<ProcuradorJuridicoDTO[]>('/usuarios/procuradores-juridicos');
    return data;
  },

  get: async (id: number): Promise<UserAdminDTO> => {
    const { data } = await api.get<UserAdminDTO>(`/admin/users/${id}`);
    return data;
  },

  create: async (payload: UserAdminCreateRequest): Promise<UserAdminDTO> => {
    const { data } = await api.post<UserAdminDTO>('/admin/users', payload);
    return data;
  },

  update: async (id: number, payload: UserAdminUpdateRequest): Promise<UserAdminDTO> => {
    const { data } = await api.put<UserAdminDTO>(`/admin/users/${id}`, payload);
    return data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(`/admin/users/${id}`);
  },
};

export default userAdminService;
